/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import axios from '@nextcloud/axios';
import { generateOcsUrl } from '@nextcloud/router';
export const generateToken = async () => {
    const { data } = await axios.get(generateOcsUrl('/apps/files_sharing/api/v1/token'));
    return data.ocs.data.token;
};
